import React from 'react';
import Text from '@/components/ui/Text';

interface EmptyStateProps {
  /** Rendered under the copy — the filtered case offers a way out, the zero case has nothing to clear. */
  action?: React.ReactNode;
  body?: string;
  title: string;
}

const EmptyState = ({ action, body, title }: EmptyStateProps) => (
  <div className="tw-py-8 tw-text-center">
    <Text className="tw-text-tci-black tw-mb-1" weight="bold">{title}</Text>
    {body && <Text className="tw-text-dark-grey" size="sm">{body}</Text>}
    {action && <div className="tw-mt-3">{action}</div>}
  </div>
);

export default EmptyState;
